module.exports = __webpack_public_path__ + "static/gmaillogo-290f674f91e4269060d2c5cfa9283541.png";